import axios from "axios";

// API & app URLs from env (REACT_APP_*); fallbacks for production
// export const baseURL = "http://localhost:8080/";
export const baseURL =
  process.env.REACT_APP_BASE_URL || "https://bhcsapi.asginnovations.in/";
export const frontendURL =
  process.env.REACT_APP_FRONTEND_URL || "https://bhcs.asginnovations.in/";
export const docUrl =
  process.env.REACT_APP_DOC_URL ||
  "https://bhcs.s3.ap-south-1.amazonaws.com";

axios.defaults.baseURL = baseURL;
export default axios;
